$(document).on("turbo:load", function () {
  $(".comment-reply-button").on("click", function () {
    const collapse = new bootstrap.Collapse(
      $(this).closest(".comment").find(".comment-form").get(0)
    );
    collapse.toggle();
  });
});
